import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared.module';
import { ClientesService } from '../../../features/nino/clientes/services/clientes.service';
import { ProductosService } from '../../../features/nino/productos/services/productos.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-global-search',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule],
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss']
})
export class GlobalSearchComponent implements OnInit {
  query: string = '';
  results: { type: string, icon: string, name: string, sub: string, route: any[] }[] = [];
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<GlobalSearchComponent>,
    private clientesService: ClientesService,
    private productosService: ProductosService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Foco automático al abrir
  }

  onSearch() {
    if (this.query.length < 2) {
      this.results = [];
      return;
    }

    this.isLoading = true;
    forkJoin({
      clientes: this.clientesService.listClientes(),
      productos: this.productosService.getProductos()
    }).subscribe({
      next: ({ clientes, productos }) => {
        const q = this.query.toLowerCase();
        
        const filteredClientes = clientes
          .filter(c => c.nombre.toLowerCase().includes(q) || (c.rut && c.rut.toLowerCase().includes(q)))
          .map(c => ({
            type: 'Cliente',
            icon: 'person',
            name: c.nombre,
            sub: c.rut || 'Sin RUT',
            route: ['nino-shopping/list-clientes'] // Mejorar esto si hay vista de detalle
          }));

        const filteredProductos = productos
          .filter(p => p.nombre.toLowerCase().includes(q))
          .map(p => ({
            type: 'Producto',
            icon: 'inventory_2',
            name: p.nombre,
            sub: `$${p.valor}`,
            route: ['nino-shopping/list-productos']
          }));

        this.results = [...filteredClientes, ...filteredProductos].slice(0, 8);
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  navigate(route: any[]) {
    this.router.navigate(route);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
